import React from "react";
import { Controller } from "react-hook-form";
import { isAdmin, isLimitedAdmin, isSuperAdmin } from "../../lib/roleUtils";

const Step3TeakRounds = ({
    control,
    watch,
    setValue,
    userFields,
    appendUser,
    removeUser,
    teakFields,
    appendTeak,
    removeTeak,
    lengthRefs,
    girthRefs,
    fieldRefs,
    handleKeyPress,
    handleEnterKeyPress,
    showModifyGirth,
    setShowModifyGirth,
    role,
    isLoading,
    updateLoading,
    goToPreviousStep,
    goToNextStep,
    calculateValues,
    calculateAndUpdate,
    aggregatedData,
    state,
    isEditMode
}) => {
    const item = watch("item");
    const newTeakRounds = watch("newTeakRounds") || [];
    const mtsNewValue = watch("mtsNewValue");
    const modifyTotalCBM = watch("modifyTotalCBM");
    const newValue = watch("newValue");

    return (
        <div className="card shadow-sm border rounded-top-0 rounded-bottom-3 p-3 p-md-4 d-flex flex-column justify-content-between flex-grow-1">
            <div>

                {/* ── Item Select + Action Buttons ── */}
                <div className="d-flex flex-column flex-sm-row align-items-sm-end justify-content-between gap-3 mb-4">
                    <div style={{ minWidth: "180px", flex: "1 1 auto", maxWidth: "320px" }}>
                        <label htmlFor="pl-item" className="form-label fw-semibold small text-uppercase gtss-text-primary">
                            Item
                        </label>
                        <Controller
                            name="item"
                            control={control}
                            defaultValue="TEAK ROUND LOGS"
                            render={({ field }) => (
                                <select {...field} id="pl-item" className="form-select">
                                    <option value="TEAK ROUND LOGS">TEAK ROUND LOGS</option>
                                    <option value="TEAK SAWN SIZE">TEAK SAWN SIZE</option>
                                </select>
                            )}
                        />
                    </div>

                    {isSuperAdmin(role) && (
                        <div className="d-flex flex-wrap gap-2 w-100 w-sm-auto justify-content-start justify-content-sm-end">
                            <button
                                className="btn fw-semibold text-white gtss-bg-primary border-0 px-3 py-2 text-nowrap flex-grow-1 flex-sm-grow-0"
                                type="button"
                                id="pl-modify-girth-btn"
                                onClick={() => {
                                    if (!(Number(mtsNewValue) > 0)) {
                                        setShowModifyGirth((prev) => !prev);
                                    }
                                }}
                                style={{
                                    cursor: Number(mtsNewValue) > 0 ? "not-allowed" : "pointer",
                                    opacity: Number(mtsNewValue) > 0 ? 0.6 : 1,
                                    pointerEvents: Number(mtsNewValue) > 0 ? "none" : "auto",
                                }}
                            >
                                {showModifyGirth ? "HIDE MODIFY GIRTH" : "MODIFY GIRTH"}
                            </button>

                            <button
                                type="button"
                                id="pl-reset-btn"
                                title="Click to reset girth values"
                                className="btn fw-semibold text-white border-0 px-3 py-2 text-nowrap flex-grow-1 flex-sm-grow-0"
                                style={{ backgroundColor: "#6c757d" }}
                                onClick={() => {
                                    if (Number(mtsNewValue) > 0 || Number(modifyTotalCBM) > 0 || Number(newValue) > 0) {
                                        setValue("mtsNewValue", 0);
                                        setValue("modifyTotalCBM", 0);
                                        setValue("newValue", 0);
                                        setValue("averageModifyGirth", 0);
                                        newTeakRounds?.forEach((_, index) => {
                                            setValue(`newTeakRounds.${index}.modifyGirth`, "");
                                            setValue(`newTeakRounds.${index}.modifyCbm`, "");
                                        });
                                    }
                                }}
                            >
                                RESET
                            </button>
                        </div>
                    )}
                </div>

                {/* ── Section Heading ── */}
                <h2 className="text-center fw-bold text-uppercase fs-6 py-2 mb-3 border-bottom border-top gtss-text-primary">
                    Packing List Entry
                </h2>

                {/* ── TEAK ROUND LOGS Table ── */}
                {item === "TEAK ROUND LOGS" && (
                    <>
                        {/* Modify Girth operator row */}
                        {showModifyGirth && (
                            <div className="d-flex flex-wrap align-items-center gap-3 mb-3 p-3 border rounded-3 gtss-bg-light">
                                <span className="fw-semibold small text-uppercase gtss-text-primary">M-Girth Action:</span>
                                <Controller
                                    name="girthAction"
                                    control={control}
                                    defaultValue="PLUS"
                                    render={({ field }) => (
                                        <select {...field} id="pl-girthAction" className="form-select" style={{ maxWidth: "150px" }}>
                                            <option value="PLUS">PLUS(+)</option>
                                            <option value="MINUS">MINUS(-)</option>
                                        </select>
                                    )}
                                />
                                <Controller
                                    name="newValue"
                                    control={control}
                                    defaultValue={0}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            id="pl-newValue"
                                            type="number"
                                            placeholder="0"
                                            className="form-control"
                                            style={{ maxWidth: "120px" }}
                                        />
                                    )}
                                />
                            </div>
                        )}

                        {/* Table wrapper */}
                        <div className="table-responsive mb-3">
                            <table className="table table-bordered table-hover align-middle gtss-table gtss-table-sticky mb-0 w-100" style={{ minWidth: showModifyGirth ? "600px" : "430px" }}>
                                <colgroup>
                                    <col style={{ width: "40px" }} />
                                    <col style={{ width: "105px" }} />
                                    <col style={{ width: "105px" }} />
                                    <col style={{ width: "115px" }} />
                                    {showModifyGirth && (<>
                                        <col style={{ width: "115px" }} />
                                        <col style={{ width: "115px" }} />
                                    </>)}
                                    <col style={{ width: "50px" }} />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th style={{ width: "40px" }} className="text-center">#</th>
                                        <th style={{ width: "105px" }} className="text-center">Length</th>
                                        <th style={{ width: "105px" }} className="text-center">Girth</th>
                                        <th style={{ width: "115px" }} className="text-center">CBM</th>
                                        {showModifyGirth && (
                                            <>
                                                <th style={{ width: "115px" }} className="text-center">M-Girth</th>
                                                <th style={{ width: "115px" }} className="text-center">M-CBM</th>
                                            </>
                                        )}
                                        <th style={{ width: "50px" }} className="text-center"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userFields?.map((field, index) => (
                                        <tr key={field?.id}>
                                            <td className="text-muted small">{index + 1}</td>
                                            <td>
                                                <Controller
                                                    name={`newTeakRounds.${index}.length`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            {...field}
                                                            type="number"
                                                            placeholder="0"
                                                            step="any"
                                                            className="form-control"
                                                            onChange={(e) => { field.onChange(e); calculateValues(); }}
                                                            onKeyPress={(e) => handleKeyPress(e, index, "length")}
                                                            ref={(el) => (lengthRefs.current[index] = el)}
                                                        />
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                <Controller
                                                    name={`newTeakRounds.${index}.girth`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            {...field}
                                                            type="number"
                                                            placeholder="0"
                                                            className="form-control"
                                                            step="any"
                                                            onChange={(e) => { field.onChange(e); calculateValues(); }}
                                                            onKeyPress={(e) => handleKeyPress(e, index, "girth")}
                                                            ref={(el) => (girthRefs.current[index] = el)}
                                                        />
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                <Controller
                                                    name={`newTeakRounds.${index}.cbm`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            {...field}
                                                            type="number"
                                                            step="any"
                                                            disabled
                                                            readOnly
                                                            className="form-control bg-light"
                                                            placeholder="0.000"
                                                        />
                                                    )}
                                                />
                                            </td>
                                            {showModifyGirth && (
                                                <>
                                                    <td>
                                                        <Controller
                                                            name={`newTeakRounds.${index}.modifyGirth`}
                                                            control={control}
                                                            render={({ field }) => (
                                                                <input
                                                                    {...field}
                                                                    type="number"
                                                                    placeholder="0"
                                                                    className="form-control bg-light"
                                                                    step="any"
                                                                    readOnly
                                                                    onChange={(e) => { field.onChange(e); calculateValues(); }}
                                                                />
                                                            )}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Controller
                                                            name={`newTeakRounds.${index}.modifyCbm`}
                                                            control={control}
                                                            render={({ field }) => (
                                                                <input
                                                                    {...field}
                                                                    type="number"
                                                                    step="any"
                                                                    disabled
                                                                    readOnly
                                                                    className="form-control bg-light"
                                                                    placeholder="0.000"
                                                                />
                                                            )}
                                                        />
                                                    </td>
                                                </>
                                            )}
                                            <td className="text-center">
                                                {index !== 0 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        aria-label={`Remove row ${index + 1}`}
                                                        onClick={() => removeUser(index)}
                                                    >
                                                        ✕
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                {/* ── Simple summary row — AVG LEN | AVG GIRTH | TOT.CBM | T_NOS | AVG CFT (hidden for admin role) ── */}
                                {!isAdmin(role) && (
                                    <tfoot>
                                        <tr className="table-light">
                                            <td></td>
                                            <td>
                                                <span className="d-block small fw-semibold text-muted text-uppercase mb-1">Avg Len</span>
                                                <Controller name="avgLength" control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" readOnly className="form-control form-control-sm bg-light" placeholder="0.00" />
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                <span className="d-block small fw-semibold text-muted text-uppercase mb-1">Avg Girth</span>
                                                <Controller name="avgGirth" control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" readOnly className="form-control form-control-sm bg-light" placeholder="0.00" />
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                <span className="d-block small fw-semibold text-muted text-uppercase mb-1">Tot.CBM</span>
                                                <Controller name="totalCbm" control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" readOnly className="form-control form-control-sm bg-light" placeholder="0.000" />
                                                    )}
                                                />
                                            </td>
                                            {showModifyGirth && (
                                                <>
                                                    <td>
                                                        <span className="d-block small fw-semibold text-muted text-uppercase mb-1">Avg M-Girth</span>
                                                        <Controller name="averageModifyGirth" control={control}
                                                            render={({ field }) => (
                                                                <input {...field} type="number" step="any" readOnly className="form-control form-control-sm bg-light" placeholder="0.00" />
                                                            )}
                                                        />
                                                    </td>
                                                    <td>
                                                        <span className="d-block small fw-semibold text-muted text-uppercase mb-1">Tot M-CBM</span>
                                                        <Controller name="modifyTotalCBM" control={control}
                                                            render={({ field }) => (
                                                                <input {...field} type="number" step="any" readOnly className="form-control form-control-sm bg-light" placeholder="0.000" />
                                                            )}
                                                        />
                                                    </td>
                                                </>
                                            )}
                                            <td></td>
                                        </tr>
                                        <tr className="table-light">
                                            <td></td>
                                            <td colSpan={2}>
                                                <span className="d-block small fw-semibold text-muted text-uppercase mb-1">T_NOS</span>
                                                <Controller name="totalNos" control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" readOnly className="form-control form-control-sm bg-light" placeholder="0" />
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                <span className="d-block small fw-semibold text-muted text-uppercase mb-1">Avg CFT</span>
                                                <Controller name="avgCft" control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" readOnly className="form-control form-control-sm bg-light" placeholder="0.00" />
                                                    )}
                                                />
                                            </td>
                                            <td colSpan={showModifyGirth ? 3 : 1}></td>
                                        </tr>
                                    </tfoot>
                                )}
                            </table>
                        </div>
                    </>
                )}

                {/* ── TEAK SAWN SIZE Table ── */}
                {item === "TEAK SAWN SIZE" && (
                    <>
                        <div className="table-responsive mb-3" style={{ maxWidth: "100%", overflowX: "auto" }}>
                            <table className="table table-bordered table-hover align-middle gtss-table gtss-table-sticky mb-0" style={{ tableLayout: "fixed" }}>
                                <colgroup>
                                    <col style={{ width: "50px" }} />
                                    <col style={{ width: "120px" }} />
                                    <col style={{ width: "120px" }} />
                                    <col style={{ width: "120px" }} />
                                    <col style={{ width: "100px" }} />
                                    <col style={{ width: "120px" }} />
                                    <col style={{ width: "60px" }} />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th style={{ width: "50px" }}>#</th>
                                        <th>Width</th>
                                        <th>Thickness</th>
                                        <th>Length</th>
                                        <th>Pieces</th>
                                        <th>CBM</th>
                                        <th style={{ width: "60px" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {teakFields?.map((field, index) => (
                                        <tr key={field?.id}>
                                            <td className="text-muted small">{index + 1}</td>
                                            <td>
                                                <Controller name={`newTeakSwans.${index}.width`} control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" placeholder="0" className="form-control"
                                                            onChange={(e) => { field.onChange(e); calculateAndUpdate(); }}
                                                            onKeyPress={(e) => handleEnterKeyPress(e, "width", index)}
                                                            ref={(el) => (fieldRefs.current.width[index] = el)}
                                                        />
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                <Controller name={`newTeakSwans.${index}.thickness`} control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" placeholder="0" className="form-control"
                                                            onChange={(e) => { field.onChange(e); calculateAndUpdate(); }}
                                                            onKeyPress={(e) => handleEnterKeyPress(e, "thickness", index)}
                                                            ref={(el) => (fieldRefs.current.thickness[index] = el)}
                                                        />
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                <Controller name={`newTeakSwans.${index}.length`} control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" placeholder="0" className="form-control"
                                                            onChange={(e) => { field.onChange(e); calculateAndUpdate(); }}
                                                            onKeyPress={(e) => handleEnterKeyPress(e, "length", index)}
                                                            ref={(el) => (fieldRefs.current.length[index] = el)}
                                                        />
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                <Controller name={`newTeakSwans.${index}.noOfPieces`} control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" placeholder="0" className="form-control"
                                                            onChange={(e) => { field.onChange(e); calculateAndUpdate(); }}
                                                            onKeyPress={(e) => handleEnterKeyPress(e, "noOfPieces", index)}
                                                            ref={(el) => (fieldRefs.current.noOfPieces[index] = el)}
                                                        />
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                <Controller name={`newTeakSwans.${index}.cbm`} control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" readOnly className="form-control bg-light" placeholder="0.000" />
                                                    )}
                                                />
                                            </td>
                                            <td className="text-center">
                                                {index !== 0 && (
                                                    <button type="button" className="btn btn-sm btn-outline-danger"
                                                        aria-label={`Remove row ${index + 1}`} onClick={() => removeTeak(index)}>
                                                        ✕
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="table-light">
                                    {/* Aggregated sizes summary */}
                                    {aggregatedData && aggregatedData?.length > 0 ? (
                                        aggregatedData?.map((agg, idx) => (
                                            <tr key={idx}>
                                                <td></td>
                                                <td><span className="small text-muted">SIZES</span></td>
                                                <td>
                                                    <input type="text" readOnly value={agg?.sizes} className="form-control bg-light" />
                                                </td>
                                                <td><span className="small text-muted">NOS</span></td>
                                                <td>
                                                    <input type="number" readOnly value={agg?.nos} className="form-control bg-light" />
                                                </td>
                                                <td>
                                                    <input type="number" readOnly value={agg?.cbm?.toFixed(3)} className="form-control bg-light" />
                                                </td>
                                                <td></td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td></td>
                                            <td colSpan={6} className="text-center text-muted small">
                                                No aggregated data yet
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td></td>
                                        <td colSpan={3}></td>
                                        <td>
                                            <div className="d-flex align-items-center gap-1">
                                                <span className="small fw-semibold text-muted">TOT.NOS</span>
                                                <Controller name="totalTeakNos" control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" readOnly className="form-control bg-light" placeholder="0" />
                                                    )}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center gap-1">
                                                <span className="small fw-semibold text-muted">TOT.CBM</span>
                                                <Controller name="totalTeakCbm" control={control}
                                                    render={({ field }) => (
                                                        <input {...field} type="number" step="any" readOnly className="form-control bg-light" placeholder="0.000" />
                                                    )}
                                                />
                                            </div>
                                        </td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </>
                )}
            </div>

            {/* ── Navigation Buttons ── */}
            <div className="text-center pt-2 pb-1 d-flex flex-wrap justify-content-center gap-2 gap-sm-3">
                {isAdmin(role) || isLimitedAdmin(role) ? (
                    <button
                        type="submit"
                        id="pl-step3-submit-btn"
                        className="btn px-5 py-2 fw-semibold text-white gtss-bg-accent border-0"
                        style={{ borderRadius: "20px" }}
                        disabled={isLoading || updateLoading}
                    >
                        {isLoading || updateLoading ? "Saving..." : isEditMode ? "Update" : "Submit"}
                    </button>
                ) : (
                    <>
                        <button
                            type="button"
                            id="pl-step3-back-btn"
                            className="btn btn-light px-5 py-2 fw-semibold border"
                            style={{ borderRadius: "20px" }}
                            onClick={goToPreviousStep}
                        >
                            Back
                        </button>
                        <button
                            type="button"
                            id="pl-step3-next-btn"
                            className="btn px-5 py-2 fw-semibold text-white gtss-bg-primary border-0"
                            style={{ borderRadius: "20px" }}
                            onClick={goToNextStep}
                        >
                            Next
                        </button>
                        <button
                            type="submit"
                            id="pl-step3-submit-btn"
                            className="btn px-5 py-2 fw-semibold text-white gtss-bg-accent border-0"
                            style={{ borderRadius: "20px" }}
                            disabled={isLoading || updateLoading}
                        >
                            {isLoading || updateLoading ? "Saving..." : isEditMode ? "Update" : "Submit"}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default Step3TeakRounds;
